import { useTranslation } from 'react-i18next';

import loaderSvg from '@/assets/icons/loader.svg';

import './loading-spinner.css';

export function LoadingSpinner() {
  const { t } = useTranslation();

  return (
    <img src={loaderSvg} alt={t('loading')} className="loading-spinner__img" />
  );
}
